import {isLoggedIn} from '@github-ui/client-env'
import {dismissOrganizationNoticePath} from '@github-ui/paths'
import {verifiedFetch} from '@github-ui/verified-fetch'
import {useCallback} from 'react'

export function useDismissOrgNotice(noticeName: string, orgName: string, ownerId: string) {
  const dismissNotice = useCallback(() => {
    if (!isLoggedIn()) return

    const form = new FormData()
    form.append('_method', 'delete')
    form.append('input[notice]', noticeName)
    form.append('input[organizationId]', ownerId)
    form.append('input[forWholeOrg]', 'true')

    verifiedFetch(dismissOrganizationNoticePath({org: orgName}), {
      method: 'DELETE',
      body: form,
    })
  }, [noticeName, orgName, ownerId])

  return {dismissNotice}
}
